<template>
	<div>
	<el-row :gutter="10">
      <el-col :span="12" :offset="6" :xs="{'span': 24, 'offset': 0}">
        <el-card class="box-card" v-loading="loading">
            <el-row :gutter="20">
                <el-col :span="10" :offset="14" :xs="{'span': 24, 'offset': 0}">
                  <el-select v-model="selected_budget" placeholder="Бюджет" @change="reloadData">
                      <el-option v-for="item in budgets" :key="item.id" :label="item.description" :value="item.id"></el-option>
                  </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <AmountComponent title="Дохід" :amount="overall_income" />
                </el-col>
                <el-col :span="6" :offset="3">
                    <AmountComponent title="Обов'язкові витрати" :amount="overall_planned_expenses" />
                </el-col>
                <el-col :span="6" :offset="3">
                    <AmountComponent title="Збереження" :amount="planned_savings" />
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <AmountComponent title="На день" :amount="per_day" />
                </el-col>
                <el-col :span="6" :offset="3">
                    <AmountComponent title="На тиждень" :amount="per_week" />
                </el-col>
                <el-col :span="6" :offset="3">
                    <AmountComponent title="На місяць" :amount="per_month" />
                </el-col>
            </el-row>
          <el-row>
                <el-col :span="24">
                    <SpendingProgressBar title="Загалом" :spent_amount="all_spent_amount" :planned_amount="overall_income"/>
                </el-col>
          </el-row>

          <el-row>
                <el-col :span="24">
                   Обов'язкові витрати
                </el-col>
            </el-row>
          <el-row>
                <el-col :span="24">
                    <SpendingProgressBar title="Загалом" :spent_amount="required_categories_spent_amount"
                                         :planned_amount="overall_planned_expenses"/>
                </el-col>
          </el-row>
            <el-row v-for="category in required_categories" :key="category.id">
                <el-col :span="24">
                    <SpendingProgressBar :title="category.category" :spent_amount="category.spent_amount"
                                         :planned_amount="category.planned_amount"/>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                   Категорії
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <SpendingProgressBar title="Загалом" :spent_amount="usual_categories_spent_amount" :planned_amount="per_month" />
                </el-col>
            </el-row>
            <el-row v-for="category in usual_categories" :key="category.id">
                <el-col :span="24">
                    <SpendingProgressBar :title="category.category" :spent_amount="category.spent_amount"
                                         :planned_amount="category.planned_amount"/>
                </el-col>
            </el-row>

        </el-card>
      </el-col>
    </el-row>
</div>
</template>

<script>
import AmountComponent from '@/components/AmountComponent'
import SpendingProgressBar from '@/components/SpendingProgressBar'

import {getAllBudgets, getBudget} from "@/api/budget.api";

export default {
  name: 'budget_view',
  components: {
    AmountComponent,
    SpendingProgressBar
  },
  data: () => ({
    selected_budget: '',
    budgets: [],
    loading: true,
    overall_income: 0,
    per_day: 0,
    per_week: 0,
    per_month: 0,
    planned_savings: 0,
    overall_planned_expenses: 0,
    required_categories: [],
    usual_categories: [],
    all_spent_amount: 0,
    required_categories_spent_amount: 0,
    usual_categories_spent_amount: 0
  }),
  async created() {
    await this.getBudgets()
    await this.reloadData();
    this.loading = false;
  },
  methods: {
    async getBudgets(){
      this.loading = true;
      const response = await getAllBudgets();
      this.budgets = response.data
      this.selected_budget = response.data[0].id
      this.loading = false;
    },

    async reloadData() {
      this.loading = true;
      const response = await getBudget(this.selected_budget);
      this.overall_income = response.data.overall_income;
      this.overall_planned_expenses = response.data.overall_planned_expenses;
      this.planned_savings = response.data.planned_savings;

      this.per_day = response.data.per_day;
      this.per_week = response.data.per_week;
      this.per_month = response.data.per_month;

      this.required_categories = response.data.required_categories;
      this.usual_categories = response.data.usual_categories;

      this.all_spent_amount = response.data.all_spent_amount;
      this.required_categories_spent_amount = response.data.required_categories_spent_amount;
      this.usual_categories_spent_amount = response.data.usual_categories_spent_amount;

      this.loading = false;
    },
  }
}
</script>

<style>
  .el-select{
    float: right;
  }

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>